/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * reason the overview Edit action is unavailable for a service agreement
 * @export
 */
export const ServiceAgreementEditBlockedReason = {
    LodExpiryRequired: 'LOD_EXPIRY_REQUIRED',
    ManageAgreementsRoleRequired: 'MANAGE_AGREEMENTS_ROLE_REQUIRED'
} as const;
export type ServiceAgreementEditBlockedReason = typeof ServiceAgreementEditBlockedReason[keyof typeof ServiceAgreementEditBlockedReason];


export function instanceOfServiceAgreementEditBlockedReason(value: any): boolean {
    for (const key in ServiceAgreementEditBlockedReason) {
        if (Object.prototype.hasOwnProperty.call(ServiceAgreementEditBlockedReason, key)) {
            if (ServiceAgreementEditBlockedReason[key as keyof typeof ServiceAgreementEditBlockedReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ServiceAgreementEditBlockedReasonFromJSON(json: any): ServiceAgreementEditBlockedReason {
    return ServiceAgreementEditBlockedReasonFromJSONTyped(json, false);
}

export function ServiceAgreementEditBlockedReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementEditBlockedReason {
    return json as ServiceAgreementEditBlockedReason;
}

export function ServiceAgreementEditBlockedReasonToJSON(value?: ServiceAgreementEditBlockedReason | null): any {
    return value as any;
}

export function ServiceAgreementEditBlockedReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): ServiceAgreementEditBlockedReason {
    return value as ServiceAgreementEditBlockedReason;
}

